@if (loading()) {
  <div class="nt-loading-shade">
    <mat-spinner color="primary"></mat-spinner>
  </div>
}

<div class="wrapper">
  <!-- top navbar-->
  <app-header></app-header>
  <!-- Main section-->
  <section class="main-content">
    <div class="card content-wrapper">
      <div class="step-content">
        <router-outlet></router-outlet>
      </div>
    </div>
  </section>
  <!-- Page footer-->
  <footer class="footer-container" app-footer></footer>
  <app-cookies-banner></app-cookies-banner>
</div>
